<template>
  <div class="fair-survey-step fair-survey-step--centered">
    <div class="fair-survey-step__head fair-survey-step__head--centered">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle completion-step__text"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <FairButton
      class="completion-step__cta"
      label="Посмотреть образ"
      variant="primary"
      size="m"
      :rounded="false"
      @click="handleViewCapsule"
    />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useLookModal } from '@/features/look/store'
import type { LookStep } from '@/features/look/types/look-config'
import { FairButton } from '@/ui/primitives/FairButton'

interface Props {
  step: LookStep & { type: 'completion' }
}

const props = defineProps<Props>()
const lookStore = useLookModal()
const router = useRouter()

const isSubmitted = ref(false)

async function handleViewCapsule() {
  if (!isSubmitted.value) {
    // Если опрос еще не отправлен, отправляем его
    if (!lookStore.lookModal.capsuleId) {
      try {
        await lookStore.submitLookSurvey()
        isSubmitted.value = true
      } catch (error) {
        console.error('Error submitting look survey:', error)
        return
      }
    } else {
      isSubmitted.value = true
    }
  }

  // Переход на страницу capsule
  const capsuleId = lookStore.lookModal.capsuleId
  if (capsuleId) {
    router.push(`/capsule/${capsuleId}`)
    lookStore.hideLookModal()
  }
}

onMounted(async () => {
  // Если опрос еще не отправлен, отправляем его
  if (!lookStore.lookModal.capsuleId) {
    try {
      await lookStore.submitLookSurvey()
      isSubmitted.value = true
    } catch (error) {
      console.error('Error submitting look survey:', error)
    }
  } else {
    isSubmitted.value = true
  }

  // Автоматический редирект на страницу capsule после небольшой задержки (fallback)
  const capsuleId = lookStore.lookModal.capsuleId
  if (capsuleId) {
    setTimeout(() => {
      if (!isSubmitted.value) {
        router.push(`/capsule/${capsuleId}`)
        lookStore.hideLookModal()
      }
    }, 2000)
  }
})
</script>

<style scoped>
.fair-survey-step--centered {
  justify-content: center;
  align-items: center;
}

.completion-step__text {
  max-width: 480px;
  text-align: center;
}

.completion-step__cta {
  align-self: center;
}
</style>
